import { render, staticRenderFns } from "./RDSUsers.vue?vue&type=template&id=5e3dfff0&"
import script from "./RDSUsers.vue?vue&type=script&lang=js&"
export * from "./RDSUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports